import {
  Card,
  Radio,
} from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import * as React from 'react';
import { Bar, BarChart, LabelList, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import MyanmarMap from '../../components/MyanmarMap';
import { TownshipData } from '../../store';

const capitalFormatter = (value: string) => `$${Number(value).toFixed(2)}MM`;

interface P {
  stateCode: string | undefined;
  loading: boolean;
  townships: TownshipData[];
}
interface S {
  stateCode: string | undefined;
  townshipCode: string | undefined;
  mode: 'map' | 'bar';
}
export default class extends React.Component<P, S> {
  constructor(props: P) {
    super(props);
    this.state = { mode: 'map', stateCode: props.stateCode, townshipCode: undefined };
  }

  handleModeChange = (e: RadioChangeEvent) => {
    const value = e.target.value;
    this.setState({ mode: value });
  }

  onStateSelect = (code: string) => () => {
    this.setState({ stateCode: code, townshipCode: undefined });
  }

  onTownshipSelect = (code: string) => () => {
    this.setState({ townshipCode: code });

  }

  onUnselectFunc = () => {
    this.setState({ stateCode: undefined, townshipCode: undefined });
  }

  render() {
    const { loading, townships, stateCode } = this.props;
    const { mode } = this.state;

    return (
      <Card
        title="Townships"
        loading={loading}
        extra={
          <Radio.Group value={mode} onChange={this.handleModeChange} size="small">
            <Radio.Button value="map">Map</Radio.Button>
            <Radio.Button value="bar">Bar</Radio.Button>
          </Radio.Group>
        }
      >
        {mode === 'bar' &&
          <ResponsiveContainer width="100%" height={865}>
            <BarChart
              layout="vertical"
              data={townships}
              margin={{ top: 20, right: 80, left: 20, bottom: 5 }}
            >
              <XAxis type="number" />
              <YAxis type="category" dataKey="township" tickLine={false} width={150} />
              <Bar dataKey="capital" fill="#8884d8">
                <LabelList dataKey="capital" position="right" formatter={capitalFormatter} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        }
        {mode === 'map' && !loading &&
          <MyanmarMap
            size={[346, 525]}
            selectedState={stateCode}
            data={townships}
          // onTownshipSelect={this.onTownshipSelect}
            onStateSelect={this.onStateSelect}
          // onUnselectFunc={this.onUnselectFunc} 
          />
        }
      </Card>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Dashboard/components/FDIForTownships.tsx